import { Fragment } from 'react';

import { TransferLogs } from '../component/TransferLogs';

export default function BangTongHopTransferLog() {
  return (
    <Fragment>
      <TransferLogs type="Summary" showInvoiceInfo={false} />
    </Fragment>
  );
}
